import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin-top: -15px;
  :not(:last-child) {
    margin-bottom: 50px;
  }
  width: 100%;
  height: 100%;
`;
const Title = styled.div`
  font-size: 22px;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Content = styled.div`
  margin-top: 25px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 125px);
  grid-gap: 15px;
  @media (max-width: 768px) {
    justify-content: space-between;
  }
`;

export const DetailSection = ({ title, children }) => {
  return (
    <Container>
      <Title>{title}</Title>
      <Content>{children}</Content>
    </Container>
  );
};
